import { Component, OnInit, ViewEncapsulation, Input, ElementRef, ViewChild, AfterViewChecked, AfterViewInit } from '@angular/core';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableExtraParams } from 'projects/common/src/app/interfaces/table/table-extra-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { ITableLargeColumnConfig } from 'projects/common/src/app/interfaces/table/table-large-column-config';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { ITableShiftLoops, ITraductionModal } from '../../../../../interfaces/sp/productionbymachine';
import { LanguageService } from 'projects/common/src/app/services/parameters';

@Component({
  selector: 'app-shift-loops-production',
  templateUrl: './shift-loops-production.component.html',
  styleUrls: ['./shift-loops-production.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ShiftLoopsProductionComponent implements OnInit, AfterViewChecked {
  public tableConfig;
  public traductionModal: ITraductionModal;

  @ViewChild('scroll', { static: true })
  public scrollContainer: ElementRef;
  public disableShadowBottom = false;
  public disableShadowTopBottom = true;
  public disableShadowTop = true;
  public widthScrollContainer = 0;

  @Input()
  public data: ITableShiftLoops[];

  @Input()
  public machineObjCode: string;

  constructor(
    private tableConfigService: TableConfigService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private _languageService: LanguageService,
  ) {}

  /**
   * On init component
   */
  public ngOnInit(): void {
    this.getTraductionProduction(this.machineObjCode);
    const headers = this.data;
    this.setTableConfig(headers);
    let customEvent = {};
    if ('drillingsmts' in this.data) {
      customEvent = {
        tab_modal: 'production-by-machine_drillings',
      };
    } else {
      customEvent = {
        tab_modal: 'production-by-operator_loops',
      };
    }
    this.googleAnalyticsService.sendCustomEvent('modal', customEvent);
  }

  private getTraductionProduction(machineType: string): void {
    switch (machineType) {
      case 'LHD':
        this.traductionModal = {
          productionShift: {
            titleHeaderTable: this._languageService.message('shelves'),
          },
        };
        break;
      case 'JMB':
        this.traductionModal = {
          productionShift: {
            titleHeaderTable: this._languageService.message('drilling'),
          },
        };

        break;
      case 'TRU':
        this.traductionModal = {
          productionShift: {
            titleHeaderTable: this._languageService.message('loops'),
          },
        };

        break;
      default:
        break;
    }
  }
  /**
   * After View checked
   */
  public ngAfterViewChecked(): void {
    const element = this.scrollContainer.nativeElement;
    if (element.scrollHeight > element.clientHeight) {
      this.widthScrollContainer = this.scrollContainer.nativeElement.getBoundingClientRect().width - 10;
    }
  }

  /**
   * Function to set a table by config
   */
  private setTableConfig(tableData: any[]): void {
    const largeColumns = ['operator'];

    const customLargeColumns: ITableLargeColumnConfig[] = [
      { field: 'operator', isLargeColumn: true, flexGrow: 1.5 },
      { field: 'machineName', isLargeColumn: true, flexGrow: 1.5 },
    ];

    const headerParams: ITableHeaderParams = {
      data: tableData,
      largeColumns,
      replaceColumnName: [
        { prevName: 'machineName', newName: 'machineType' },
        { prevName: 'durationAtSeconds', newName: 'durationdrillat' },
        { prevName: 'drillingmts', newName: 'drillings_mts' },
        { prevName: 'loops', newName: this.traductionModal?.productionShift?.titleHeaderTable },
      ],
      customLargeColumns,
    };
    const datasetParams: ITableDataParams = {
      tableData,
      largeColumns,
      customLargeColumns,
    };
    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);
    const extraParams: ITableExtraParams = {
      noDataMsg: 'm019',
      disableFooter: true,
      minimalRows: tableData.length,
      quantityPerPage: tableData.length,
    };

    this.tableConfig = null;
    setTimeout(() => (this.tableConfig = { header, dataset, extraParams }), 0);
  }

  /**
   * On scroll component
   */
  public onScroll(): void {
    const element = this.scrollContainer.nativeElement;
    const atBottom = Math.floor(element.scrollHeight - element.scrollTop) === element.clientHeight;
    const atTop = element.scrollTop === 0;

    if (atTop && !atBottom) {
      this.disableShadowBottom = false;
      this.disableShadowTop = true;
      this.disableShadowTopBottom = true;
    } else if (!atTop && !atBottom) {
      this.disableShadowBottom = true;
      this.disableShadowTop = true;
      this.disableShadowTopBottom = false;
    } else if (!atTop && atBottom) {
      this.disableShadowBottom = true;
      this.disableShadowTop = false;
      this.disableShadowTopBottom = true;
    }
  }
}
